export enum HubspotErrorCode {
  MISSING_PRIMARY_DOMAIN = 'missing-primary-domain',
  COMPANY_NOT_FOUND = 'company-not-found',
  MULTIPLE_COMPANIES_FOUND = 'multiple-companies-found',
  MISSING_COMPANY_ID = 'missing-company-id',
  COMPANY_DOES_NOT_EXIST = 'company-does-not-exist',
  CONTACT_NOT_FOUND = 'contact-not-found',
}

export type HubspotErrorLog = {
  id: string;
  code: HubspotErrorCode | string;
  params: Record<string, string | number>;
  created: string;
  lastOccurredAt: string;
  account: { id: string; name: string };
  owner: { firstName: string | null; lastName: string | null } | null;
  subjectName: string | null;
};

export type HubspotErrorLogsRequest = {
  take: number;
  skip: number;
};

export type HubspotErrorLogsResponse = {
  result: HubspotErrorLog[];
  count: number;
  fetched: number;
};

export type HubspotErrorLogSummary = { count: number };
